import { effectScope, getCurrentScope, onScopeDispose } from "vue";
import { Chat } from "@ai-sdk/vue";
import { useObservability } from "./useObservability.js";
import {
  WebSocketChatTransport
} from "../chat/chat-transport.js";
const CHAT_MESSAGES = "cf_agent_chat_messages";
const CHAT_CLEAR = "cf_agent_chat_clear";
export const useAgentChat = (clientOrConnection, options = {}) => {
  const scope = getCurrentScope() ?? effectScope();
  return scope.run(() => {
    const connection = "connection" in clientOrConnection ? clientOrConnection.connection : clientOrConnection;
    const obs = useObservability();
    const chat = new Chat({
      id: options.id,
      transport: new WebSocketChatTransport(connection),
      onError: (error) => {
        obs.error(error, { function: "useAgentChat" });
      }
    });
    const onMessage = (event) => {
      const { data } = event;
      if (typeof data !== "string") return;
      let frame;
      try {
        frame = JSON.parse(data);
      } catch {
        return;
      }
      if (chat.status !== "ready" && chat.status !== "error") return;
      if (frame.type === CHAT_CLEAR) chat.messages = [];
      if (frame.type === CHAT_MESSAGES && Array.isArray(frame.messages)) {
        chat.messages = frame.messages;
      }
    };
    connection.addEventListener("message", onMessage);
    onScopeDispose(() => {
      connection.removeEventListener("message", onMessage);
      void chat.stop();
    });
    return chat;
  });
};
